/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SDDCStateEnum } from './sDDCStateEnum';


export interface SDDCInfo { 
    /**
     * Time at which SDDC was created
     */
    created_at: string;
    /**
     * User who created SDDC
     */
    created_by: string;
    /**
     * SDDC UUID
     */
    id: string;
    /**
     * Various number of instance type
     */
    instance_type: { [key: string]: number; };
    /**
     * SDDC Name
     */
    name: string;
    /**
     * Number of ESX hosts in SDDC
     */
    num_esx_host?: number;
    /**
     * Org Id
     */
    org_id: string;
    /**
     * AWS region in which SDDC resides
     */
    region?: string;
    state: SDDCStateEnum;
}
export namespace SDDCInfo {
}


